exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Menu-List-Sector {\n  width: 100%;\n}\n.Company-Row:hover {\n  color: #0d73d8;\n}\n.Brand-Container-Sector:hover {\n  background: #eff8ff;\n  color: #0d73d8;\n}\n.Brand-Container-Sector {\n  margin-left: 42px;\n  cursor: pointer;\n}\n", ""]);

